import * as Yup from "yup";

//REVISAR Y COMPLETAR AL MOMENTO DE CONECTAR CON MOBILE, CONOCER LAS VARIABLES Y TENER DISPONIBLES LOS ENDPOINTS

export const hooksValidationSchema = Yup.object({
    trigger: Yup.string().required("Requerido"),
    action: Yup.string().required("Requerido"),
    company: Yup.object({ id: Yup.string().required("Requerido") }),
});
